import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromHomeStore from './home-store.reducer';
import { CommonSelectors } from '..';

export const selectHomeStoreState = createFeatureSelector<fromHomeStore.State>(fromHomeStore.homeStoreFeatureKey);

export const selectStatisticsData = createSelector(selectHomeStoreState, (state) => state.statisticsData);

export const selectNewsCount = createSelector(selectHomeStoreState, (state) => state.news.length);

export const selecteStatisticsVM = createSelector(selectStatisticsData, (statisticsData) => {
    return {
        totalSampleCount: statisticsData.reduce((acc, curr) => acc + curr.samplecount, 0),
        totalMeasureCount: statisticsData.reduce((acc, curr) => acc + curr.measurecount, 0),
        measurements: statisticsData.slice().sort((a, b) => {
            return a['id'] < b['id'] ? -1 : a['id'] > b['id'] ? 1 : 0;
        }),
    };
});

export const selectNewsVM = createSelector(selectHomeStoreState, (state) => {
    return {
        news: state.news.slice().sort((a, b) => {
            return <any>new Date(b.updatedOn || b.creationDate) - <any>new Date(a.updatedOn || a.creationDate);
        }),
        loadedAllNews: state.loadedAllNews,
    };
});

export const selectSelectedNewsDetails = createSelector(selectHomeStoreState, CommonSelectors.selectConstants, (homeState, constants) => {
    const newsItem = homeState.news.find((n) => n.contentId === homeState.selectedNewsId);

    if (!newsItem) {
        return null;
    }

    let featureImage = newsItem.attachments?.filter((item) => {
        return item.contentAttachmentTypeId == 1;
    })[0];

    const attachmentsList = [
        ...newsItem.attachments?.filter((item) => {
            return item.contentAttachmentTypeId == 2;
        }),
    ].map((item) => {
        return {
            ...item,
            url: `${constants.apiUrl}/search/getattachment/` + item.contentAttachmentId,
        };
    });

    const sortedNews = [...homeState.news].sort((a, b) => {
        return <any>new Date(b.updatedOn || b.creationDate) - <any>new Date(a.updatedOn || a.creationDate);
    });

    return {
        news: homeState.news.slice(1, homeState.news.length),
        newsEnriched: sortedNews
            .slice(1, homeState.news.length)
            .map((item) => {
                const fImages = item?.attachments?.filter((item) => {
                    return item.contentAttachmentTypeId == 1;
                });
                const fImage = fImages ? fImages[0] : undefined;

                return {
                    ...item,
                    bgImageUrl: fImage ? `${constants.apiUrl}/search/getattachment/` + fImage?.contentAttachmentId : undefined,
                };
            }),
        ...newsItem,
        bgImageUrl: featureImage ? `${constants.apiUrl}/search/getattachment/` + featureImage.contentAttachmentId : undefined,
        attachmentsList: attachmentsList || [],
    };
});
